var map = {
	"./ChevronIcon": [
		16674
	],
	"./ChevronIcon.tsx": [
		16674
	],
	"./EffectIcon": [
		74982,
		4982
	],
	"./EffectIcon.tsx": [
		74982,
		4982
	],
	"./SparkleIcon": [
		49195,
		9195
	],
	"./SparkleIcon.tsx": [
		49195,
		9195
	],
	"./Spinner": [
		19470,
		9470
	],
	"./Spinner.tsx": [
		19470,
		9470
	],
	"./account.svg": [
		74029,
		4029
	],
	"./alert.svg": [
		61017,
		1017
	],
	"./arrows/ArrowIcon": [
		84508,
		4508
	],
	"./arrows/ArrowIcon.tsx": [
		84508,
		4508
	],
	"./arrows/SolidArrowIcon": [
		3774,
		3774
	],
	"./arrows/SolidArrowIcon.tsx": [
		3774,
		3774
	],
	"./arrows/arrow_down.svg": [
		36846,
		6846
	],
	"./arrows/solid_arrow_down.svg": [
		51500,
		4741
	],
	"./bag.svg": [
		80158,
		158
	],
	"./bag_stylized.svg": [
		49570,
		9570
	],
	"./beaker.svg": [
		86805,
		6805
	],
	"./blob.svg": [
		94648,
		4648
	],
	"./brand_store.svg": [
		17808,
		7808
	],
	"./calendar.svg": [
		7930,
		7930
	],
	"./cannabinoids/cbc.svg": [
		68677,
		8677
	],
	"./cannabinoids/cbd.svg": [
		91951,
		1951
	],
	"./cannabinoids/cbg.svg": [
		6964,
		6964
	],
	"./cannabinoids/thc.svg": [
		85152,
		5152
	],
	"./cannabinoids/thcv.svg": [
		87551,
		7551
	],
	"./cart.svg": [
		42912
	],
	"./cart_alt.svg": [
		64979,
		4979
	],
	"./chat.svg": [
		49055
	],
	"./chat_bubble.svg": [
		89356,
		9356
	],
	"./check_mark.svg": [
		48605
	],
	"./chevron_down.svg": [
		59213
	],
	"./circle_check_mark.svg": [
		70519,
		519
	],
	"./circle_x.svg": [
		51751,
		1751
	],
	"./coinList/accessory.svg": [
		50421,
		421
	],
	"./coinList/cartridge.svg": [
		17514,
		7514
	],
	"./coinList/concentrate.svg": [
		72688,
		2688
	],
	"./coinList/delta8.svg": [
		55226,
		5226
	],
	"./coinList/edible.svg": [
		4351,
		4351
	],
	"./coinList/flower.svg": [
		436,
		436
	],
	"./coinList/growing.svg": [
		10934,
		934
	],
	"./coinList/other.svg": [
		18573,
		1913
	],
	"./coinList/preroll.svg": [
		64300,
		1789
	],
	"./coinList/topical.svg": [
		26733,
		6733
	],
	"./coinList/vape.svg": [
		58357,
		8357
	],
	"./consumption/cartridge.svg": [
		39116,
		9116
	],
	"./consumption/concentrate.svg": [
		62287,
		2287
	],
	"./consumption/edible.svg": [
		21972,
		1972
	],
	"./consumption/flower.svg": [
		77900,
		7900
	],
	"./consumption/preroll.svg": [
		43994,
		3994
	],
	"./consumption/vape.svg": [
		44145,
		4145
	],
	"./deals-tags.svg": [
		68812,
		8812
	],
	"./download_banner_logo.svg": [
		11482
	],
	"./effects/anxious.svg": [
		58729,
		8729
	],
	"./effects/aroused.svg": [
		24328,
		4328
	],
	"./effects/creative.svg": [
		4186,
		4186
	],
	"./effects/dizzy.svg": [
		52711,
		2711
	],
	"./effects/dry-eyes.svg": [
		88921,
		8921
	],
	"./effects/dry-mouth.svg": [
		74014,
		4014
	],
	"./effects/energetic.svg": [
		78033,
		8033
	],
	"./effects/euphoric.svg": [
		66955,
		6955
	],
	"./effects/focused.svg": [
		49017,
		9017
	],
	"./effects/giggly.svg": [
		90690,
		690
	],
	"./effects/happy.svg": [
		54914,
		4914
	],
	"./effects/headache.svg": [
		97983,
		7983
	],
	"./effects/hungry.svg": [
		46828,
		6828
	],
	"./effects/paranoid.svg": [
		4010,
		4010
	],
	"./effects/relaxed.svg": [
		21981,
		1981
	],
	"./effects/sleepy.svg": [
		76189,
		6189
	],
	"./effects/talkative.svg": [
		3992,
		3992
	],
	"./effects/tingly.svg": [
		12933,
		2933
	],
	"./effects/uplifted.svg": [
		44364,
		4364
	],
	"./ellipse_filled.svg": [
		57351,
		7351
	],
	"./exclamation.svg": [
		66062,
		6062
	],
	"./filter.svg": [
		30033,
		33
	],
	"./filter_list.svg": [
		45909,
		5909
	],
	"./find_store_stylized.svg": [
		70343,
		343
	],
	"./flavors/ammonia.svg": [
		12280,
		2280
	],
	"./flavors/apple.svg": [
		9572,
		9572
	],
	"./flavors/apricot.svg": [
		94211,
		4211
	],
	"./flavors/berry.svg": [
		35211,
		5211
	],
	"./flavors/blue-cheese.svg": [
		69730,
		9730
	],
	"./flavors/blueberry.svg": [
		94164,
		4164
	],
	"./flavors/butter.svg": [
		16295,
		6295
	],
	"./flavors/cheese.svg": [
		86162,
		6162
	],
	"./flavors/chemical.svg": [
		57458,
		7458
	],
	"./flavors/chestnut.svg": [
		38014,
		8014
	],
	"./flavors/citrus.svg": [
		50937,
		937
	],
	"./flavors/coffee.svg": [
		3950,
		3950
	],
	"./flavors/diesel.svg": [
		30062,
		62
	],
	"./flavors/earthy.svg": [
		80405,
		405
	],
	"./flavors/flowery.svg": [
		19102,
		9102
	],
	"./flavors/grape.svg": [
		82074,
		2074
	],
	"./flavors/grapefruit.svg": [
		47227,
		7227
	],
	"./flavors/honey.svg": [
		26945,
		6945
	],
	"./flavors/lavender.svg": [
		52822,
		2822
	],
	"./flavors/lemon.svg": [
		18,
		18
	],
	"./flavors/lime.svg": [
		30584,
		584
	],
	"./flavors/mango.svg": [
		96007,
		6007
	],
	"./flavors/menthol.svg": [
		83583,
		3583
	],
	"./flavors/mint.svg": [
		31627,
		1627
	],
	"./flavors/nutty.svg": [
		80962,
		962
	],
	"./flavors/orange.svg": [
		58694,
		8694
	],
	"./flavors/peach.svg": [
		99079,
		9079
	],
	"./flavors/pear.svg": [
		37530,
		7530
	],
	"./flavors/pepper.svg": [
		84075,
		4075
	],
	"./flavors/pine.svg": [
		28992,
		8992
	],
	"./flavors/pineapple.svg": [
		38590,
		8590
	],
	"./flavors/plum.svg": [
		99580,
		9580
	],
	"./flavors/pungent.svg": [
		79084,
		9084
	],
	"./flavors/rose.svg": [
		40211,
		211
	],
	"./flavors/sage.svg": [
		38940,
		8940
	],
	"./flavors/skunk.svg": [
		22462,
		2462
	],
	"./flavors/spicy-herbal.svg": [
		59660,
		9660
	],
	"./flavors/strawberry.svg": [
		44729,
		3673
	],
	"./flavors/sweet.svg": [
		26647,
		6647
	],
	"./flavors/tar.svg": [
		236,
		236
	],
	"./flavors/tea.svg": [
		51330,
		1330
	],
	"./flavors/tobacco.svg": [
		73471,
		3471
	],
	"./flavors/tree-fruit.svg": [
		24964,
		4964
	],
	"./flavors/tropical.svg": [
		21515,
		1515
	],
	"./flavors/vanilla.svg": [
		20657,
		657
	],
	"./flavors/violet.svg": [
		32113,
		2113
	],
	"./flavors/woody.svg": [
		25753,
		5753
	],
	"./guest_signup_illustration.svg": [
		35232,
		5232
	],
	"./hamburger_menu.svg": [
		32991
	],
	"./heart_filled.svg": [
		93139,
		3139
	],
	"./heart_outline.svg": [
		36821,
		6821
	],
	"./info.svg": [
		34678,
		4678
	],
	"./interlocking_circles.svg": [
		22627,
		2627
	],
	"./knowledge.svg": [
		40248,
		248
	],
	"./legal-logo.svg": [
		53039
	],
	"./location_marker.svg": [
		4523
	],
	"./location_search.svg": [
		54662,
		4662
	],
	"./logo.svg": [
		6282
	],
	"./map.svg": [
		28131,
		8131
	],
	"./medical_cross.svg": [
		43201,
		3201
	],
	"./minus.svg": [
		23845,
		3845
	],
	"./no_delivery_results.svg": [
		58965,
		8965
	],
	"./not_found.svg": [
		75513,
		5513
	],
	"./open_in_new.svg": [
		22088,
		2088
	],
	"./paperclip.svg": [
		19524,
		9524
	],
	"./pencil.svg": [
		34474,
		4474
	],
	"./phenotypes/hybrid.svg": [
		32583,
		2583
	],
	"./phenotypes/indica.svg": [
		38697,
		8697
	],
	"./phenotypes/sativa.svg": [
		27758,
		7758
	],
	"./phone.svg": [
		49278,
		9278
	],
	"./phone_mobile.svg": [
		86424
	],
	"./plus.svg": [
		46741,
		6741
	],
	"./plus_stylized.svg": [
		84033,
		4033
	],
	"./productTypes/cartridge.svg": [
		67480,
		7480
	],
	"./productTypes/clone.svg": [
		46397,
		6397
	],
	"./productTypes/concentrate.svg": [
		71297,
		1297
	],
	"./productTypes/edible.svg": [
		4582,
		4582
	],
	"./productTypes/flower.svg": [
		23508,
		3508
	],
	"./productTypes/other.svg": [
		32252,
		2252
	],
	"./productTypes/preroll.svg": [
		92162,
		2162
	],
	"./productTypes/seeds.svg": [
		77863,
		7863
	],
	"./productTypes/topical.svg": [
		19449,
		9449
	],
	"./productTypes/topicals.svg": [
		5764,
		5764
	],
	"./prop65_warning.svg": [
		49573,
		9573
	],
	"./refresh.svg": [
		45311,
		5311
	],
	"./scooter.svg": [
		58624,
		8624
	],
	"./scooter_stylized.svg": [
		62349,
		2349
	],
	"./search.svg": [
		91738
	],
	"./search/420.svg": [
		91056,
		1056
	],
	"./search/cannabis_101.svg": [
		66668,
		6668
	],
	"./search/gift_guide.svg": [
		35864,
		5864
	],
	"./search/grow_guide.svg": [
		42311,
		7021
	],
	"./search/pain_relief.svg": [
		10851,
		851
	],
	"./search/reward.svg": [
		75727,
		5727
	],
	"./search/strain.svg": [
		86191,
		6191
	],
	"./searchBar/search.svg": [
		35278,
		5278
	],
	"./searchBar/x.svg": [
		90122,
		122
	],
	"./send_paper_plane.svg": [
		26953,
		6953
	],
	"./shapes.svg": [
		45367,
		5367
	],
	"./share/email.svg": [
		25342,
		5342
	],
	"./share/facebook.svg": [
		32092
	],
	"./share/instagram.svg": [
		30415
	],
	"./share/linkedin.svg": [
		80693,
		693
	],
	"./share/pinterest.svg": [
		49172,
		9172
	],
	"./share/twitter.svg": [
		44956
	],
	"./share/youtube.svg": [
		1556
	],
	"./shopping_bag_stylized.svg": [
		99822,
		9822
	],
	"./shopping_cart_stylized.svg": [
		20544,
		544
	],
	"./similar-effects.svg": [
		88248,
		8248
	],
	"./star_outline.svg": [
		42291,
		2291
	],
	"./star_solid.svg": [
		81131
	],
	"./stevo_flower.svg": [
		60728,
		728
	],
	"./store.svg": [
		12356,
		3751
	],
	"./store_with_background.svg": [
		94986,
		4986
	],
	"./storefront.svg": [
		49891,
		9891
	],
	"./strain-prize-mono.svg": [
		34615,
		4615
	],
	"./strain-prize.svg": [
		3932,
		3932
	],
	"./strain-quiz-loader.svg": [
		75552,
		5552
	],
	"./terpene.svg": [
		34290,
		4290
	],
	"./thc-level/high.svg": [
		26900,
		6900
	],
	"./thc-level/low.svg": [
		99266,
		9266
	],
	"./thc-level/medium.svg": [
		23950,
		297
	],
	"./thc-level/none.svg": [
		62161,
		2161
	],
	"./thumb_down_stylized.svg": [
		66843,
		6843
	],
	"./thumb_up_outline.svg": [
		12824,
		2824
	],
	"./thumb_up_solid.svg": [
		59963,
		9963
	],
	"./thumb_up_stylized.svg": [
		39087,
		9087
	],
	"./user_position_marker.svg": [
		57995,
		7995
	],
	"./verified.svg": [
		55534,
		5534
	],
	"./website.svg": [
		42066,
		2066
	],
	"./weed_cart.svg": [
		56504,
		6504
	],
	"./wordpress.svg": [
		75707,
		5707
	],
	"./x.svg": [
		40491
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 59127;
module.exports = webpackAsyncContext;